import React from 'react'

function Billing() {
  return (
    <div>  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.75 8.25033H19.25"
      stroke="#202020"
      stroke-width="1.7"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.41699 13.7503H8.25033"
      stroke="#202020"
      stroke-width="1.7"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <rect
      x="2.75"
      y="3.66699"
      width="16.5"
      height="13.75"
      rx="3"
      stroke="#202020"
      stroke-width="1.7"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg></div>
  )
}

export default Billing